 <template> 
	<div class="window">
        <div class="header"><span>{{ translation.wasze_odpowiedzi }}</span>
            <a class="settings" @click="openSettings"><cog-6-tooth-icon class="icon"/></a>
        </div>
        <div class="description-box">
            <div class="players">
                <div class="player">{{ elements[0].realName1 }}</div>
                <div class="player">{{ elements[0].realName2 }}</div>
            </div>
            <div class="question-container">
                <div v-for="element in elements" :key="element.oppRowID">
                    <div class="question">
                        <span class="question">{{ element.name }}</span>
                        <div class="hearts">
                            <span class="heart" v-if="element.answerOpponent==element.answerOpponentCheck">❤️</span>
                            <span class="heart" v-if="element.answerMe==element.answerMeCheck">❤️</span>                        
                        </div>
                    </div>
                    <div class="answers-container">
                        <div class="answer" :class="element.answerOpponent==element.answerOpponentCheck?'answer-correct':'answer-incorrect'">
                            <span class="answer-user">{{ element.user2 }}</span>:
                            <span class="answer-text" v-if="element.answerOpponent==1">{{ replaceUserNames(element.user1, element.answer1) }}</span>
                            <span class="answer-text" v-if="element.answerOpponent==2">{{ replaceUserNames(element.user2, element.answer2) }}</span>
                        </div><!-- user2: answerOpponent -->
                        <div class="answer" :class="element.answerOpponent==element.answerOpponentCheck?'answer-correct':'answer-incorrect'">
                            <span class="answer-user">{{ element.user2 }}</span>:
                            <span class="answer-text" v-if="element.answerOpponentCheck==1">{{ replaceUserNames(element.user1, element.answer1) }}</span>
                            <span class="answer-text" v-if="element.answerOpponentCheck==2">{{ replaceUserNames(element.user2, element.answer2) }}</span>
                        </div><!-- user2: = answerOpponentCheck -->
                    </div>
                    <div class="answers-container">
                        <div class="answer" :class="element.answerMe==element.answerMeCheck?'answer-correct':'answer-incorrect'">
                            <span class="answer-user">{{ element.user1 }}</span>:
                            <span class="answer-text" v-if="element.answerMe==1">{{ replaceUserNames(element.user1, element.answer1) }}</span>
                            <span class="answer-text" v-if="element.answerMe==2">{{ replaceUserNames(element.user2, element.answer2) }}</span>
                        </div><!-- user1: answerMe -->
                        <div class="answer" :class="element.answerMe==element.answerMeCheck?'answer-correct':'answer-incorrect'">
                            <span class="answer-user">{{ element.user1 }}</span>:
                            <span class="answer-text" v-if="element.answerMeCheck==1">{{ replaceUserNames(element.user1, element.answer1) }}</span>
                            <span class="answer-text" v-if="element.answerMeCheck==2">{{ replaceUserNames(element.user2, element.answer2) }}</span>
                        </div><!-- user1: answerMeCheck -->
                    </div>
                </div>

            </div>
        </div>

        <div class="to-bottom">
            <button class="btn btn-all btn-return"  @click="returnToCategories" v-html="translation.powrot_do_kategorii"></button>
            <button class="btn btn-all btn-green"  @click="startGame" v-html="translation.graj_dalej"></button>
        </div>
    </div>
</template>

<script>
import de from '../locale/de.js';
import en from '../locale/en.js';
import es from '../locale/es.js';
import fr from '../locale/fr.js';
import it from '../locale/it.js';
import pl from '../locale/pl.js';
import pt from '../locale/pt.js';
import { Cog6ToothIcon } from '@heroicons/vue/24/solid';

export default {
    name: 'NaszeOdpowiedzi',
    props: {
        language: String,
        klucz: String,
        category:Number,
        subcategory:Number
    },
    components: { 
        Cog6ToothIcon,
    },
    data() {
        return {
            lang: localStorage.getItem('language'),
            translation: pl,
            theme: localStorage.getItem('theme'),
            elements: '',
        }
    },
    beforeMount() {
        switch(localStorage.getItem('language'))
        {
            case 'de':
                this.translation = de;
                break;
            case 'en':
                this.translation = en;
                break;
            case 'es':
                this.translation = es;
                break;
            case 'fr':
                this.translation = fr;
                break;
            case 'it':
                this.translation = it;
                break;
            case 'pt':
                this.translation = pt;
                break;
            default:
                this.translation = pl;
                break;
        }
        //console.log(this.category+'-'+this.subcategory);
        //this.elements = JSON.parse(localStorage.getItem('levels-'+this.category+'-'+this.subcategory)).odpowiedzi;
        console.log('Te dane dostaje '+this.category+'-'+this.subcategory)
        this.getData();
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData() {
            this.$emit('show-spinner',true);
            let data = localStorage.getItem('levels-'+this.category+'-'+this.subcategory);
            data = JSON.parse(data)
            data = data.odpowiedzi
            this.elements = data;
            this.$emit('show-spinner',false);
        },
        replaceUserNames(user, answer) {
            return answer.replace('[imie1]',user)
        },
        startGame() {
            this.$emit('go-start-gry','gracz1');
        },
        openSettings() {
            this.$emit('open-settings');
        },
        openDescription() {
            this.$emit('open-description');
        },
        backToContinue() {
            this.$emit('back-to-continue');
        },
        returnToCategories() {
            this.$emit('go-to-poziomy');
        },
        returnToAnswers() {
            this.$emit('go-to-nasze-odpowiedzi');
        }
    },
    watch: {
        language(l) {
            this.lang = l;
            switch(localStorage.getItem('language'))
            {
                case 'de':
                    this.translation = de;
                    break;
                case 'en':
                    this.translation = en;
                    break;
                case 'es':
                    this.translation = es;
                    break;
                case 'fr':
                    this.translation = fr;
                    break;
                case 'it':
                    this.translation = it;
                    break;
                case 'pt':
                    this.translation = pt;
                    break;
                default:
                    this.translation = pl;
                    break;
            }

        }
    },
}
</script>

<style scoped>
.to-bottom {
    position: fixed;
    left:0;
    right:0;
    bottom:10px;
    padding: 0 20px;
}
.header {
    font-weight:bold;
    border-bottom: 1px solid var(--bs-gradient-to);
    -webkit-box-shadow: 0px 0px 10px 0px rgba(243, 40, 120, 1);
    -moz-box-shadow: 0px 0px 10px 0px rgba(243, 40, 120, 1);
    box-shadow: 0px 0px 10px 0px rgba(243, 40, 120, 1);
    color: white;
    height:50px;
    display: block;
    line-height: 50px;
    position:fixed;
    top:0;
    left:0;
    right:0;
    text-align:left;
    padding: 0 20px;
    background-color: var(--bs-gradient-to);
}
a.settings svg {
    width: 25px;
    position:absolute;
    right: 20px;
    top:12px;
}
a.description svg {
    width: 25px;
    position:absolute;
    right: 60px;
    top:12px;
}
.description-box {
    padding: 0 20px;
    background-color:var(--bs-button-background);
    color: var(--bs-button-text);
    position: fixed;
    top: 50px;
    left: 0;
    right: 0;
    bottom: 200px;
    overflow: auto;
}
.btn.btn-all {
    font-size: 1em;
    height: 3em;
    width: 100%;
    border-radius: 10px;
    margin: 5px auto;
    font-weight:bold;
    position: relative;
}
button.btn {
    font-size: 1em;
    font-family: 'Jost', sans-serif;
}
.btn-green {
    background-color: var(--bs-gradient-to);
    color: var(--bs-pink-button-color);
    position: relative;
    border-color:white;
    border: 0 none;
}
.btn-green::after {
    content: '';
    position: absolute;
    right: 20px;
    top: 50%;
    width: 12px;
    height: 12px;
    border-right: 2px solid var(--bs-pink-button-color);
    border-bottom: 2px solid var(--bs-pink-button-color);
    transform: translateY(-50%) rotate(-45deg);
    animation: chevronPulse 1s infinite;
    transition: transform 0.3s ease;
}

.btn-gold {
    background-color: var(--bs-gold);
    color: var(--bs-pink-button-color);
    position: relative;
    border-color:white;
    border: 0 none;
}
.btn-gold::after {
    content: '';
    position: absolute;
    right: 20px;
    top: 50%;
    width: 12px;
    height: 12px;
    border-right: 2px solid var(--bs-pink-button-color);
    border-bottom: 2px solid var(--bs-pink-button-color);
    transform: translateY(-50%) rotate(-45deg);
    transition: transform 0.3s ease;
}

.btn-return {
    background-color: transparent;
    border:1px solid var(--bs-button-text);
    color: var(--bs-button-text);
    position: relative;
    border-color:var(--bs-button-text);
}
.btn-return::after {
    content: '';
    position: absolute;
    left: 20px;
    top: 50%;
    width: 12px;
    height: 12px;
    border-right: 2px solid var(--bs-button-text);
    border-bottom: 2px solid var(--bs-button-text);
    transform: translateY(-50%) rotate(135deg);
    transition: transform 0.3s ease;
}

@keyframes chevronPulse {
    0%, 100% {
        transform: translateY(-50%) rotate(-45deg) translateX(0);
        opacity: 1;
    }
    50% {
        transform: translateY(-3px) rotate(-45deg) translateX(5px);
        opacity: 0.5;
    }
}
.mt2x {
    margin: 2em 0 0.5em;
}
.congratulation-box {
    background: var(--bs-box-background);
    border: var(--bs-settings-button-border);
    border-radius: 8px;
    padding: 20px 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    position: relative;
    overflow: hidden;

}
.congratulation-box::before {
    content: '🏆';
    position: absolute;
    top: 0;
    right: 10px;
    font-size: 80px;
    opacity: 0.85;
    transform: rotate(15deg);
}
.congratulation-box::after {
    content: '🏆';
    position: absolute;
    top: 0;
    left: 10px;
    font-size: 80px;
    opacity: 0.85;
    transform: rotate(-15deg);
}
.congratulation-text {
    position: relative;
    z-index: 1;
    color: var(--bs-settings-button-color-active);
    line-height: 1.5;
    margin: 0;
}
.congratulation-text.line1 {
    font-weight: 600;
    color:white;
    display:block;
    text-align:left;
    border-bottom:1px solid white;
    margin-bottom:2em;
}

.congratulation-text.line2 {
    color:white;
    display:block;
    text-align:left;
    border-bottom:1px solid #aaa;
}
.line2 {
    display: flex !important;
    padding: 5px 0 3px;
    
}
.line2 span:first-child {
  margin-right: auto;
}

.line2 span:last-child {
  white-space: nowrap;
}

.progressbar {
    height: 3px;
    position: relative;    margin-bottom:0.5em;

}

.progressbar .filled {
    background-color: var(--bs-gold);
    height:100%;
    position:absolute;
    left:0;
    top:0;
    bottom:0;
}
.players {
    display: flex;
    position:fixed;
    top:50px;
    background-color:transparent;
    z-index:100;
    height: 50px;
    left:0;
    right:0;
    background-color: var(--bs-gold);
}
.players .player {
    flex: 1;
    padding: 10px;
    position: relative;
    font-weight: bold;
}

.players .player:first-child::after {
    content:'❤️';
    font-size: 25px;
    position: absolute;
    right:-12px;
    top: 10px;
    animation: heartbeat 1.5s ease-in-out infinite;

}

.question-container {
    position: fixed;
    top:100px;
    left:0;
    right:0;
    bottom: 130px;
    padding-bottom:40px;
    overflow:auto;
}

@keyframes heartbeat {
    0% {
        transform: scale(1);
    }
    14% {
        transform: scale(1.3);
    }
    28% {
        transform: scale(1);
    }
    42% {
        transform: scale(1.3);
    }
    70% {
        transform: scale(1);
    }
    100% {
        transform: scale(1);
    }
}

div.question {
    position: relative;
    padding: 10px 0;
    border-bottom: 1px solid #aaa;
}

div.question span.question {
    font-weight:bold;
    display: block;
    text-align:center;
    padding: 0 50px;
}

div.hearts {
    position: absolute;
    right:5px;
    top:10px;
}

div.hearts span.heart {
    width:20px;
    height:20px;
    display: inline-block;
}

.answers-container {
    display: flex;
}

.answers-container .answer {
    flex:1;
    padding: 10px 5px;
        border-bottom:1px solid #aaa;

}
.answers-container .answer:first-child {
    border-right:1px solid #aaa;
}
.answers-container .answer-correct {
    background-color: var(--bs-gradient-to);

}
</style>
